module.exports = __webpack_public_path__ + "img/bubble.23632e3b.jpg";